import { useShallow } from "zustand/react/shallow";
import EUChangeManagementContent from "../changeManagement/EUMDR/EUChangeManagementContent";
import EUChangeManagementInit from "../changeManagement/EUMDR/EUChangeManagmentInit";
import { useEUChangeManagementStore } from "../../store/useEUChangeManagementStore";

export function EUChangeTab() {
  const decisionFlow = useEUChangeManagementStore(
    (state) => state.decisionFlow
  );

  return (
    <>
      {decisionFlow.length === 0 && <EUChangeManagementInit />}
      {decisionFlow.length > 0 && <EUChangeManagementContent />}
    </>
  );
}
